export enum LogType {
  Trigger = 'Trigger',
  Action = 'Action',
  Predicate = 'Predicate',
  Rule = 'Rule',
}

export interface AuditEntry {
  changedFrom?: any; // TODO: define type when we have more clarity around extensible types
  changedTo?: any; // TODO: define type when we have more clarity around extensible types
  entityChanged: LogType;
  auditAction: string;
  changedAt: string;
  changedByUserProfileKey: string;
  [key: string]: any;
}

export interface LogItemGroup {
  isExpanded: boolean;
  items: AuditEntry[];
}
